// External libraries
import React from 'react';
import type { SerializedStyles } from '@emotion/core';

import { LoadingElement } from './LoadingElement';

interface LoadingFieldsProps {
  numLoaders?: number;
  styleOverrides?: SerializedStyles;
}
const LoadingFields = ({
  numLoaders = 5,
  styleOverrides,
}: LoadingFieldsProps): React.ReactElement => {
  const loaders = new Array(numLoaders);

  return (
    <>
      {/* this caused a bug in prod where loaders were not shown */}
      {/* eslint-disable-next-line prefer-spread */}
      {Array.apply(null, loaders).map((_, i) => (
        <LoadingElement key={i} styleOverrides={styleOverrides} />
      ))}
    </>
  );
};

export { LoadingFields };
